// @flow
import { call, put } from 'redux-saga/effects';
import { setPlans } from './';
import { tripica } from '../../api';
import WizzeeLog from '../../lib/wizzeeLog';

export function* fetchAllPlans(): Generator<*, *, *> {
  try {
    const plans = yield call([tripica, 'getAllPlans']);
    yield put(setPlans(plans));
  } catch (e) {
    WizzeeLog.warn('[saga] fetchAllPlans', e);
    return { error: e };
  }
}
